import * as React from "react";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsightsCache: Record<string, ApplicationInsights> = {};

if (typeof window !== "undefined") {
  window.appInsightsCache = appInsightsCache;
}

const APP_INSIGHTS_INDEXER = "__APP_INSIGHTS_INSTRUMENTATION_KEY__";

declare const window: {
  [APP_INSIGHTS_INDEXER]?: string | null;
  appInsightsCache?: typeof appInsightsCache;
};

export const useAppInsights = (): ApplicationInsights | null => {
  const [appInsights] = React.useState(() => {
    if (typeof window === "undefined") {
      return null;
    }

    if (
      APP_INSIGHTS_INDEXER in window &&
      window[APP_INSIGHTS_INDEXER] != null
    ) {
      if (appInsightsCache[window[APP_INSIGHTS_INDEXER]]) {
        return appInsightsCache[window[APP_INSIGHTS_INDEXER]];
      }

      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: window[APP_INSIGHTS_INDEXER],
        },
      });

      appInsightsCache[window[APP_INSIGHTS_INDEXER]] = appInsights;

      return appInsights;
    }

    return null;
  });

  React.useEffect(() => {
    if (appInsights) {
      appInsights.loadAppInsights();
    }
  }, []);

  return appInsights;
};
